import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RevisionIdSchema, RunIdSchema, } from "../primitives/ids.js";
import { PackPinSchema } from "./generation-run.js";
import { ComponentSelectionSchema } from "./component-selection.js";
import { FallbackDecisionSchema } from "./intent-planner.js";
import { RecipeDecisionLogV1Schema } from "./recipe-decision-log.js";
/** build-manifest.v1.0 — minimal Tier 0 Step 2 manifest */
export const BuildManifestV1Schema = z
    .object({
    schemaVersion: z.literal("build-manifest.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    recipeId: z.string().min(1),
    packPin: PackPinSchema,
    businessGraphSnapshotHash: z.string().min(1),
    renderedAt: z.string().datetime(),
    primaryArtifactName: z.string().min(1),
    lensId: z.string().min(1).optional(),
    strategyId: z.string().min(1).optional(),
    surfaceType: z.string().min(1).optional(),
    referenceId: z.string().min(1).optional(),
    businessGraphFixtureId: z.string().min(1).optional(),
    compositionLockId: z.string().min(1).optional(),
    plannerVersion: z.string().min(1).optional(),
    businessGraphRevisionId: RevisionIdSchema.optional(),
    componentSelections: z.array(ComponentSelectionSchema).optional(),
    fallbackDecisions: z.array(FallbackDecisionSchema).optional(),
    recipeDecisionLog: RecipeDecisionLogV1Schema.optional(),
    qualityGateStatus: z.string().min(1).optional(),
    visualQualityGateStatus: z.string().min(1).optional(),
    artifactSetHash: z.string().min(1).optional(),
    /** GN-001 — durable engine pin on every build */
    engineVersion: z.string().min(1).optional(),
    /** GN-001 / GN-005 — resolved lens semver at render time */
    lensVersion: z.string().min(1).optional(),
    clientSafe: z.boolean().optional(),
    exportStatus: z.string().min(1).optional(),
})
    .strict();
export const RichBuildManifestV1Schema = BuildManifestV1Schema.extend({
    schemaVersion: z.literal("build-manifest.v1.1"),
    lensId: z.string().min(1),
    strategyId: z.string().min(1).optional(),
    surfaceType: z.string().min(1).optional(),
    plannerVersion: z.string().min(1),
    componentSelections: z.array(ComponentSelectionSchema),
    fallbackDecisions: z.array(FallbackDecisionSchema),
    recipeDecisionLog: RecipeDecisionLogV1Schema,
    artifactSetHash: z.string().min(1),
    clientSafe: z.boolean(),
}).strict();
//# sourceMappingURL=build-manifest.js.map